import qoalaStorage from '~/core/Storage';
import { parseIfJsonString } from '~/core/helper/JSONHelper';

export default {
  getActiveList: state => {
    return qoalaStorage.getItem('activeList')
      ? parseIfJsonString(qoalaStorage.getItem('activeList'))
      : state.activeList;
  },
  getStoreList: state =>
    qoalaStorage.getItem('storeList') ? parseIfJsonString(qoalaStorage.getItem('storeList')) : state.storeList,
  getPolicies: state =>
    qoalaStorage.getItem('policies') ? parseIfJsonString(qoalaStorage.getItem('policies')) : state.policies,
  getPolicy: state =>
    qoalaStorage.getItem('policy') ? parseIfJsonString(qoalaStorage.getItem('policy')) : state.policy,
  getPolicyList: state => state.policyList || [],
  getClaims: state =>
    qoalaStorage.getItem('claims') ? parseIfJsonString(qoalaStorage.getItem('claims')) : state.claims,
  getClaim: state => (qoalaStorage.getItem('claim') ? parseIfJsonString(qoalaStorage.getItem('claim')) : state.claim),
  getBenefits: state =>
    qoalaStorage.getItem('benefits') ? parseIfJsonString(qoalaStorage.getItem('benefits')) : state.benefits,
  getUpcoming: state =>
    qoalaStorage.getItem('upcoming') ? parseIfJsonString(qoalaStorage.getItem('upcoming')) : state.upcoming,
  getCancelToken: state => state.cancelTokenAxios,
  getTempData: state =>
    qoalaStorage.getItem('tempDat') ? parseIfJsonString(qoalaStorage.getItem('tempDat')) : state.tempData,
  getTempDataBus: state => state.tempDataBus,
  getSmartPhoneProduct: state =>
    qoalaStorage.getItem('smartPhoneProduct')
      ? parseIfJsonString(qoalaStorage.getItem('smartPhoneProduct'))
      : state.smartPhoneProduct,
  getPurchaseConfirmation: state =>
    qoalaStorage.getItem('smartPhonePurchaseConfirmation')
      ? parseIfJsonString(qoalaStorage.getItem('smartPhonePurchaseConfirmation'))
      : state.purchaseConfirmation,
  getPurchasePayment: state =>
    qoalaStorage.getItem('smartPhonePurchasePayment')
      ? parseIfJsonString(qoalaStorage.getItem('smartPhonePurchasePayment'))
      : state.purchasePayment,
  getSmartphoneClaim: state => {
    if (!state.smartphoneClaim) {
      return '';
    }
    return state.smartphoneClaim;
  },
  getDataPolicyCreation: state =>
    qoalaStorage.getItem('dataPolicyCreation')
      ? parseIfJsonString(qoalaStorage.getItem('dataPolicyCreation'))
      : state.dataPolicyCreation
};
